import { Col, Row, Stack } from 'react-bootstrap';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useContext } from 'react';
import { LocaleContext } from 'routes/Router';
import { doctorDashboard } from 'routes/AppUrls';
import { FormattedMessage } from 'react-intl';
import ReusableButton from 'components/commom/Button';
import Lottie from 'lottie-react';
import Paymentsuccess from 'assets/lottie/paymentSuccess.json';
import Paymentfailed from 'assets/lottie/paymentFailed.json';
import { getProfileSectionData } from 'store/doctorProfileSection/doctorProfileSectionAction';
import { ClearTokenRedirectLogin } from 'utils/general';
import CommonToast from 'components/commom/CommonToast';
import { useDispatch, useSelector } from 'react-redux';
import {
  ACTIVE_INDEX,
  basicDetailsValue,
} from 'store/BasicDetailValues/BasicDetailValuesAction';

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const { locale } = useContext(LocaleContext);
  const [searchParams] = useSearchParams();
  const { showToast } = CommonToast();
  const dispatch = useDispatch();

  const profileLoader = useSelector(
    (state) => state?.profileSectionDataReducer?.loading
  );

  const handleDashboard = () => {
    const external = {
      run: true,
      handleFunction: (res) => {
        dispatch(basicDetailsValue(ACTIVE_INDEX, 0));
        navigate(doctorDashboard(locale));
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    dispatch(getProfileSectionData(external));
  };

  return (
    <div>
      <Row className="bc-FEF9F6 m-0 p-0">
        <Col
          className={
            locale === 'en'
              ? 'commonEnContainer  lg:ml-left border-l bColor-EFE3D7'
              : 'commonArContainer lg:mr-right border-l bColor-EFE3D7'
          }
        >
          <Row>
            <Col xs={12} className="p-0">
              <div className="pt-10 lg:pt-0">
                <div className="p-16 bg-light-100 border-1 bColor-EFE3D7">
                  <div className="w-full max-w-[80%] mx-auto flex flex-col items-center justify-center text-center">
                    <Stack
                      direction="horizontal"
                      gap={2}
                      className="items-center"
                    >
                      <h2 className="fc-292D32 fs-32 family_outfit_semiBold_600  m-0 mx-auto">
                        {searchParams.get('status') === 'true' ? (
                          <FormattedMessage id="Payment Successful" />
                        ) : searchParams.get('status') === 'false' ? (
                          <FormattedMessage id="Payment Unsuccessful" />
                        ) : (
                          <FormattedMessage id="Payment Status Unknown" />
                        )}
                      </h2>
                    </Stack>
                    <div className="mt-[20px] h-[200px] w-[200px] md:h-[300px] md:w-[300px]">
                      <Lottie
                        animationData={
                          searchParams.get('status') === 'true'
                            ? Paymentsuccess
                            : Paymentfailed
                        }
                        loop={true}
                      />
                    </div>
                    <div className="mt-[20px]">
                      <div className="fs-16 family_outfit_medium_400 lh-30 fc-292D32 flex items-center">
                        {searchParams.get('status') === 'true'
                          ? `Your transaction has been processed, and your
                          subscription is now active.`
                          : searchParams.get('status') === 'false'
                            ? `Your transaction could not be completed, and your subscription is not active yet. This can happen due to a declined card, insufficient balance, network issues, or your bank blocking the transaction`
                            : ''}
                      </div>
                      <div className="mt-[20px]">
                        Click on the button below to go to the Dashboard.
                      </div>
                    </div>
                    <div className="mt-[30px] w-full sm:max-w-[40%] md:max-w-[30%] 2xl:max-w-[20%]">
                      <ReusableButton
                        fullWidth={true}
                        variant="outlined"
                        color="#F5F5F5"
                        fontSize="14px"
                        fontWeight="600"
                        padding="12px 0px"
                        height="44px"
                        bgColor="#375241"
                        brColor="#375241  "
                        fontFamily="outfit_semiBold"
                        onClick={() => {
                          handleDashboard();
                        }}
                        loading={profileLoader}
                      >
                        <FormattedMessage id="Go to the Dashboard" />
                      </ReusableButton>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default PaymentSuccess;
